"use client";

import React from "react";
import { FileText } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Material Traceability & Verification",
    heading: "Require Material Certification for Your Filtration Spec?",
    lead: "Review alloy suitability, request mill test documentation when specified in your order, or discuss custom wire mesh requirements with our engineering team.",
    secondaryLabel: "Material Verification Guide"
  },
  zh: {
    eyebrow: "材料可溯源与质保",
    heading: "需要验证过滤丝网的合金材质与质保文件？",
    lead: "比对合金耐蚀性能，可按订单要求提供材质检验报告（MTR 3.1），或与我们的工程团队探讨定制丝网规格。",
    secondaryLabel: "材质验证指南"
  },
  es: {
    eyebrow: "Trazabilidad y verificación de materiales",
    heading: "¿Requiere certificación de material para su especificación de filtración?",
    lead: "Evalúe la idoneidad de la aleación, solicite certificados de prueba de fábrica según su pedido o consulte especificaciones de malla a medida con nuestro equipo de ingeniería.",
    secondaryLabel: "Guía de verificación de materiales"
  },
  de: {
    eyebrow: "Material-Rückverfolgbarkeit & Zertifizierung",
    heading: "Benötigen Sie Materialzeugnisse für Ihre Filtrationsspezifikation?",
    lead: "Prüfen Sie die Eignung der Legierung, fordern Sie Werkszeugnisse auftragsbezogen an oder besprechen Sie maßgeschneiderte Gewebespezifikationen mit unserem Team.",
    secondaryLabel: "Leitfaden zur Materialprüfung"
  },
  fr: {
    eyebrow: "Traçabilité et vérification des matériaux",
    heading: "Besoin de certificats matière pour vos spécifications de filtration ?",
    lead: "Évaluez l'adéquation de l'alliage, demandez des certificats d'usine selon votre commande ou échangez sur vos toiles sur mesure avec notre équipe technique.",
    secondaryLabel: "Guide de vérification des matériaux"
  },
  pt: {
    eyebrow: "Rastreabilidade e verificação de materiais",
    heading: "Necessita de certificação de material para sua especificação de filtração?",
    lead: "Avalie a adequação da liga, solicite relatórios de ensaio de usina conforme especificado no pedido ou consulte nossa equipe técnica sobre telas sob medida.",
    secondaryLabel: "Guía de verificação de materiais"
  }
};
export default function CertificationCTA() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="certificationcta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/StainlessSteelMaterialVerificationPage",
    icon: FileText
  }} />;
}